const indexItems = [
  { id: 1, letter: 'A', label: '娱乐圈大瓜', count: '128万帖', color: 'text-primary-500 bg-primary-50' },
  { id: 2, letter: 'B', label: '明星塌房实录', count: '96万帖', color: 'text-accent-500 bg-accent-50' },
  { id: 3, letter: 'C', label: '综艺争议现场', count: '83万帖', color: 'text-secondary-500 bg-secondary-50' },
  { id: 4, letter: 'D', label: '网红圈内幕', count: '75万帖', color: 'text-primary-500 bg-primary-50' },
  { id: 5, letter: 'E', label: '影视剧吐槽', count: '68万帖', color: 'text-accent-500 bg-accent-50' },
  { id: 6, letter: 'F', label: '恋情实锤合集', count: '61万帖', color: 'text-secondary-500 bg-secondary-50' },
  { id: 7, letter: 'G', label: '饭圈风云录', count: '55万帖', color: 'text-primary-500 bg-primary-50' },
  { id: 8, letter: 'H', label: '跨界大事件', count: '44万帖', color: 'text-accent-500 bg-accent-50' },
];

export default function IndexSection() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const el = document.querySelector('#cards');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              主题索引
            </h2>
            <p className="text-sm text-foreground-500">按分类快速找到你感兴趣的爆料话题</p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
            {indexItems.map((item) => (
              <a
                key={item.id}
                href="#cards"
                onClick={handleClick}
                className="bg-background-50 border border-background-200/70 rounded-xl p-5 text-center hover:border-primary-200 hover:-translate-y-1 transition-all duration-200 cursor-pointer"
              >
                <div className={`w-10 h-10 mx-auto mb-3 rounded-lg ${item.color} flex items-center justify-center`}>
                  <span className="text-base font-bold">{item.letter}</span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 mb-1">{item.label}</h3>
                <p className="text-xs text-foreground-400">{item.count}</p>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}